import React, { FC, useCallback } from 'react';
import { MainTemplate } from '../../components/layouts';
import { DictionaryWrapper } from '../../components/DictionaryWrapper';
import { Classifier, useClassifiersQuery, useClassifiersLazyQuery } from '../../api';
import { ClassifiersFilter } from '../../components/Filters';
import { Grid, Tooltip } from '@material-ui/core';
import { MUIDataTableColumn } from 'mui-datatables';
import { usePermission } from '../../hooks/usePermission';
import { Link, useHistory } from 'react-router-dom';
import { BtnNew } from '../../components/BtnNew';
import { useDispatch, useSelector } from 'react-redux';
import { AppStore } from '../../store/reducers';
import { getSettingsUserFilter, getSettingsUserFilterFormValue } from '../../store/selectors/settings';
import _ from 'lodash';
import { SET_USER_SETTINGS_FILTER } from '../../store/constants';
import { DataTable } from '../../components/DataTable/NewTable';

const Page: FC<{}> = () => {
  const { push } = useHistory();
  const access = usePermission('directory', 'classifiers');

  const dispatch = useDispatch();
  const filter: any = useSelector((state: AppStore) => getSettingsUserFilter(state, 'classifiers'), _.isEqual);
  const formValue: any = useSelector(
    (state: AppStore) => getSettingsUserFilterFormValue(state, 'classifiers'),
    _.isEqual,
  );

  const setFilter = useCallback(
    (filter, form) => {
      dispatch({
        type: SET_USER_SETTINGS_FILTER,
        payload: {
          name: 'classifiers',
          filter: filter,
          form,
        },
      });
    },
    [dispatch],
  );

  const columns: MUIDataTableColumn[] = [
    {
      name: 'id',
      label: 'Имя',
      options: {
        filter: false,
        sort: false,
        viewColumns: false,
        customBodyRender: (value: Pick<Classifier, 'id'>, meta: any) => {
          return (
            <React.Fragment>
              <Tooltip title="Перейти в карточку" placement="top-start">
                <Link
                  style={{
                    fontWeight: 500,
                    cursor: 'pointer',
                    textDecoration: 'none',
                  }}
                  to={`/classifier/${value}`}
                  target={'_blank'}
                >
                  {meta.rowData[1]}
                </Link>
              </Tooltip>
            </React.Fragment>
          );
        },
      },
    },
    {
      name: 'name',
      options: {
        display: false,
        viewColumns: false,
        filter: false,
      },
    },
  ];

  return (
    <MainTemplate pageName="Классификаторы" url="" title="Классификаторы">
      <ClassifiersFilter onSubmit={(filters: any, form: any) => setFilter({ ...filters }, form)} value={formValue} />
      <DictionaryWrapper>
        <DataTable
          tableName="classifiers"
          title={
            <React.Fragment>
              <Grid container spacing={2} alignItems={'center'}>
                <Grid item>
                  <h2>Классификаторы</h2>
                </Grid>
                {access.includes(2) && <Grid item>{<BtnNew onClick={() => push('/classifier/new')} />}</Grid>}
              </Grid>
            </React.Fragment>
          }
          columns={columns}
          lazyQuery={useClassifiersLazyQuery}
          filter={filter}
        />
      </DictionaryWrapper>
    </MainTemplate>
  );
};

export default Page;
